// Menu Persistent Underline Handler
// This script keeps the last clicked top-level menu item (Women/Men) underlined

document.addEventListener('DOMContentLoaded', function() {
  const STORAGE_KEY = 'lastSelectedMainMenuItem';
  
  // Get all top-level menu links
  const topLevelMenuItems = document.querySelectorAll('.menu-list__link, .menu-list__item a');
  
  // Function to remove all active states
  function clearAllActiveStates() {
    topLevelMenuItems.forEach(item => {
      item.classList.remove('menu-link--persistent-active');
    });
  }
  
  // Function to set active state
  function setActiveMenuItem(menuItem) {
    clearAllActiveStates();
    menuItem.classList.add('menu-link--persistent-active');
    
    // Store the selection in localStorage
    const menuText = menuItem.textContent.trim();
    localStorage.setItem(STORAGE_KEY, menuText);
  }
  
  // Function to restore last selected item on page load
  function restoreLastSelection() {
    const lastSelected = localStorage.getItem(STORAGE_KEY);
    if (lastSelected) {
      topLevelMenuItems.forEach(item => {
        if (item.textContent.trim() === lastSelected) {
          item.classList.add('menu-link--persistent-active');
        }
      });
    }
  }
  
  // Add click event listeners to top-level menu items
  topLevelMenuItems.forEach(menuItem => {
    // Only attach to top-level items (Women, Men, etc.)
    // Skip if it's inside a submenu
    const isTopLevel = !menuItem.closest('.mega-menu__grid, .menu-list__submenu');
    
    if (isTopLevel) {
      menuItem.addEventListener('click', function(e) {
        setActiveMenuItem(this);
      });
    }
  });
  
  // Also handle submenu clicks to keep parent highlighted
  const submenuLinks = document.querySelectorAll('.mega-menu__link');
  submenuLinks.forEach(submenuLink => {
    submenuLink.addEventListener('click', function(e) {
      // Find the parent top-level menu item
      const parentMenuItem = this.closest('.menu-list__list-item');
      if (parentMenuItem) {
        const parentLink = parentMenuItem.querySelector('.menu-list__link');
        if (parentLink) {
          setActiveMenuItem(parentLink);
        }
      }
    });
  });
  
  // Restore selection on page load
  restoreLastSelection();
  
  // Handle navigation bar (mobile) clicks
  const mobileMenuLinks = document.querySelectorAll('.menu-list--mobile .menu-list__item a');
  mobileMenuLinks.forEach(mobileLink => {
    mobileLink.addEventListener('click', function(e) {
      const menuText = this.textContent.trim();
      localStorage.setItem(STORAGE_KEY, menuText);
      
      // Also update desktop menu if it exists
      topLevelMenuItems.forEach(item => {
        if (item.textContent.trim() === menuText) {
          clearAllActiveStates();
          item.classList.add('menu-link--persistent-active');
        }
      });
    });
  });
});